"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenubarContext = void 0;
const react_1 = require("react");
exports.MenubarContext = (0, react_1.createContext)({
    handleLogoClick: () => {
        console.error('No Menubar context was created.');
    },
    modifyItems: () => () => {
        console.error('No Menubar context was created.');
    },
    drawerTitleRef: { current: null },
});
//# sourceMappingURL=menubar-context.js.map